import controller from './modal.ctrl'
import template from './modal.tmpl.html'

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {},
}
